import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { c as n } from "../../createLucideIcon-BC8wu-bu.js";
import '../../assets/AppBar.css';/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c = n("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
function p({ onExpand: r, Right: i }) {
  return /* @__PURE__ */ a("div", { className: "appBar", children: [
    /* @__PURE__ */ a("div", { className: "appBar-left", children: [
      /* @__PURE__ */ e("a", { className: "appBar-burger", onClick: r, children: /* @__PURE__ */ e(c, { size: "1.25rem" }) }),
      /* @__PURE__ */ e("span", { children: "Home" })
    ] }),
    /* @__PURE__ */ e("div", { className: "appBar-right", children: i })
  ] });
}
export {
  p as AppBar
};
//# sourceMappingURL=AppBar.js.map
